// => Import React
import React, { useState, useEffect } from "react";

//=> Import Recoil
import { useRecoilState } from "recoil";
import { searchValueAtom } from "../../recoil";

//=> Import plugins
import Helmet from "react-helmet";
import { navigate } from "gatsby"
import { BsSearch } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";

//=> Import container
import {
  modal,
  formSearch,
  inputSearch,
  close,
  body,
  searchIcon,
  inputContainer
} from "./styles.module.scss";

//=> Component
const SearchModal = ({ closeModal }) => {
  // Search Value
  const [value, setValue] = useState("")
  const [searchValue, setSearchValue] = useRecoilState(searchValueAtom)

  // close Modal
  const handlerOnClickModal = (evt) => {
    const close = evt.target.closest("#close") ? true : false;
    if (evt.target.id === "modal" || close) {
      closeModal();
    }
  };

  const handlerOnKeyDown = (e) => {
    if (e.keyCode === 27) {
      closeModal()
    }
  }

  const handlerOnChange = (e) => {
    setValue(e.target.value)
  }

  const handlerOnSubmit = (e) => {
    e.preventDefault()

    if (value.trim().length > 0) {
      console.log(searchValue)
      navigate(
        '/result',
        {
          state: {
            searchValue: value.toLowerCase()
          }
        }
      );
      setSearchValue(value.toLowerCase())
      closeModal();
      setValue("");
    }
  }

  // Return =>
  return (
    <div
      className={modal}
      id="modal"
      role="dialog"
      aria-labelledby="searchModal"
      aria-describedby="Composant de recherche"
      aria-modal="true"
      aria-hidden="false"
      tabIndex="-1"
      onClick={handlerOnClickModal}
      onKeyDown={(e) => { handlerOnKeyDown(e) }}
    >
      {/* Permet de styliser le body à partir d'un enfant */}
      <Helmet>
        <body className={body} />
      </Helmet>

      <button className={close} id="close" onClick={handlerOnClickModal} tabIndex="1000">
        <IoMdClose size="2em" />
      </button>

      <form className={formSearch} onSubmit={handlerOnSubmit}>
        <div className={inputContainer}>
          <input
            className={inputSearch}
            type="text"
            autoFocus
            required
            placeholder="Ecrire puis appuyer sur entrée"
            value={value}
            onChange={handlerOnChange}
          />
          <span className={searchIcon}> <BsSearch size="1.5em" /></span>

        </div>

      </form>
    </div>
  );
};

export default SearchModal;
